module.exports = __webpack_public_path__ + "img/s3.65a66962.png";